var app = {
	header: {
		closeButton: "Tutup",
		copyrightLabel: "Hak Cipta",
		helpLabel: "Bantuan",
		legalNoticeLabel: "Pemberitahuan Hukum",
		logoutButton: "Keluar",
		menuLabel: "Menu",
		noUserDataLabel: "Tidak ada data pengguna",
		notificationsLabel: "Notifikasi",
		privacyPolicyLabel: "Kebijakan Privasi",
		serviceAppLabel: "Aplikasi Layanan",
		settingsLabel: "Pengaturan",
		shopLabel: "Toko",
		smartFactorySuiteLabel: "Paket Smart-Factory",
		userLabel: "Profil",
		userProfileLinkText: "Profil Pengguna"
	}
};
var dashboard = {
	cancel: {
		button: "Batal"
	},
	edit: {
		button: "Edit"
	},
	reset: {
		button: "Reset"
	},
	save: {
		button: "Simpan"
	},
	share: {
		button: "Bagikan"
	}
};
var filter = {
	clear: "Reset filter",
	clearAll: "Reset semua filter"
};
var locationMap = {
	locationLink: {
		label: "Pergi ke Lokasi"
	}
};
var notifications = {
	button: {
		loadMore: "Muat lebih banyak"
	},
	date: {
		lastMonth: "Bulan lalu",
		lastWeek: "Minggu lalu",
		older: "Lebih lama",
		thisMonth: "Bulan ini",
		thisWeek: "Minggu ini",
		today: "Hari ini",
		yesterday: "Kemarin"
	},
	error: {
		general: "Saat ini notifikasi tidak dapat ditampilkan. Silakan coba lagi nanti.",
		unauthorized: "Silakan masuk untuk melihat notifikasi"
	},
	info: {
		activateSettings: "Untuk menerima notifikasi, silakan aktifkan di pengaturan",
		noNotification: "Saat ini tidak ada pesan untuk Anda."
	},
	title: "Notifikasi"
};
var scrollToTop = {
	label: "Gulir ke Atas"
};
var slider = {
	nextButton: {
		label: "Slide Selanjutnya"
	},
	paginationBullet: {
		label: "Slide"
	},
	prevButton: {
		label: "Slide Sebelumnya"
	}
};
var sorting = {
	ascending: "Menanjak",
	descending: "Menurun"
};
var userAccount = {
	address: {
		label: "Alamat Pos"
	},
	email: {
		label: "Email"
	},
	language: {
		label: "Bahasa",
		locale: "Lokal",
		select: "Pilih bahasa",
		settings: "Pengaturan bahasa"
	},
	loggedOut: {
		message: "Anda tidak masuk"
	},
	login: {
		button: "Masuk"
	},
	name: {
		label: "Nama"
	},
	phone: {
		label: "Telepon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Saring mesin",
			label: "Mesin",
			option: {
				all: "Semua Mesin"
			},
			select: "Pilih mesin"
		},
		period: {
			label: "Periode",
			option: {
				currentMonth: "Bulan ini",
				currentWeek: "Minggu ini",
				lastMonth: "Bulan lalu",
				lastWeek: "Minggu lalu",
				today: "Hari ini",
				yesterday: "Kemarin"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Widget saya"
	},
	noDescriptionAvailable: "Tidak ada deskripsi yang tersedia.",
	widget: {
		SampleMyMachines: {
			title: "Mesin Saya"
		},
		SampleMyServiceCalls: {
			title: "Panggilan Layanan"
		},
		SampleMyTrackingList: {
			title: "Daftar Pelacakan"
		},
		SampleMyUserAccount: {
			title: "Profil Saya"
		},
		SampleOperationalStatesChart: {
			title: "Kondisi Operasional"
		},
		SampleWidgetFilter: {
			title: "Pengaturan Filter"
		},
		SampleWorkloadBalanceChart: {
			title: "Keseimbangan Beban Kerja"
		}
	}
};
var translation = {
	app: app,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	notifications: notifications,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, dashboard, translation as default, filter, locationMap, notifications, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
